.
<template>
  <div class="w-full min-h-screen overflow-x-hidden overflow-y-auto bg-white" :class="showSpinner ? 'opacity-25' : ''">
    <div class="flex flex-1 h-screen">
      <main class="flex-1 h-full min-w-0 px-4 pt-4 overflow-x-hidden overflow-y-auto sm:pt-12 2xl:pt-2 lg:px-16 2xl:px-60 lg:flex"><div class="hidden lg:block w-96"></div>
        <section aria-labelledby="primary-heading" class="flex flex-col flex-1 h-full min-w-0 overflow-x-visible pt-14 lg:pt-0 lg:order-last">
          <ParticipantInfo>
            <template v-slot:header>
              <h1 class="px-4 mt-6 mb-10 text-3xl text-darkBlue lg:mt-16">
                {{ $t('vendor.payment.header') }}
              </h1>
            </template>

            <template v-slot:content>
              <VendorPreferredPaymentContent :formData="form" :isCT="isCT" @save="proceedToNext" @back="returnToPrevious" />
            </template>
          </ParticipantInfo>
        </section>
      </main>
      <AppSideNavMenu :participantDetails="participantDetails" :slide="slideName" :id="enrollmentId"/>
    </div>
  </div>
  <GenesysChat></GenesysChat>

  <!-- Spinner -->
  <div class="fixed flex justify-center my-3 text-gray-500 left-1/2 top-1/2" v-if="showSpinner">
    <svg class="h-8 mr-3 -ml-1 animate-spin w-7 text-gtBlue600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  </div>
</template>

<script>
import { useEnrollmentStore } from "@/stores/enrollment";
import GenesysChat from "@/views/Shared/GenesysChat.vue";
import { mapActions, mapState } from 'pinia';
import enrollmentService from 'Services/backend/enrollments';
import ParticipantInfo from 'Views/EnrollmentPresentation/StaticScreens/participant_info.vue';
import VendorPreferredPaymentContent from 'Views/EnrollmentPresentation/TemplateInstances/vendor_preferred_payment_content.vue';
import edpService from '../../Enrollments/EnrollmentDetails/service';
import { getEnrolleeInitials } from 'Utilities/helper';

export default {
  name: 'VendorPreferredPayment',
  components: {
    GenesysChat,
    ParticipantInfo,
    VendorPreferredPaymentContent,
  },
  data() {
    return {
      // Required for next/back
      enrollmentId: '',
      enrolleeId: '',
      enrolleeType: '',

      // Nested components
      slideName: 'Preferred Payment',
      showSpinner: true,
      participantDetails: {
        firstName: '',
        lastName: '',
      },

      // Content component
      isCT: false,
      form: {
        paymentType: 'direct.deposit',
        accountType: [],
        accountRelationship: [],
        greenInitiative: '',
        nameOnAccount: '',
        routingNumber: '',
        accountNumber: '',
        bankName: '',
        relationshipOther: '',
      },
    };
  },
  methods: {
    async proceedToNext(formData) {
      if (this.showSpinner) return;

      this.form = formData;

      // if the type is direct deposit, verify the routing number before saving
      if (formData.paymentType === 'direct.deposit') {
        const res = await enrollmentService.checkRoutingNumber(formData.routingNumber)

        if (res?.status !== 'success') {
          this.$toast(false, 'Invalid Routing Number', 'Please enter a valid routing number');
          return;
        }
      }

      enrollmentService.updateEnrolleeDetails(this.enrolleeId, this.payload).then(
        (response) => {
          edpService.processEnrolleePresentationSavedResponse(response, this.$toast.bind(this));
          this.$router.push({ name: 'E-Sign1', params: this.routeParams });
        },
        (error) => {
          edpService.processEnrolleePresentationSavedResponse(error, this.$toast.bind(this));
          console.error(error);
        },
      );
    },
    returnToPrevious() {
      if (this.showSpinner) return;
      this.$router.push({ name: 'VendorInformation2', params: this.routeParams });
    },

    getEnrolleeInitials,
    ...mapActions(useEnrollmentStore, ['loadEnrollees']),
  },
  computed: {
    routeParams() {
      return { enrollmentId: this.enrollmentId, enrolleeId: this.enrolleeId, enrolleeType: this.enrolleeType };
    },
    payload() {
      return {
        type: 'VENDOR',
        vendor: {
          step: 4,
          ...this.form
        },
      };
    },
    ...mapState(useEnrollmentStore, ['getEnrollees']),
  },
  watch: {
    getEnrollees(newEnrollees) {
      if (newEnrollees) {
        this.showSpinner = false;
        this.isCT = newEnrollees?.documents?.packet?.stateAbbrev === 'CT';
        const preferredPayment = newEnrollees?.vendor?.vendorDetails?.preferredPayment;
        if (preferredPayment) {
          this.form.paymentType = preferredPayment.paymentType;
          this.form.accountType = preferredPayment.accountType;
          this.form.accountRelationship = preferredPayment.accountRelationship;
          this.form.greenInitiative = preferredPayment.greenInitiative;
          this.form.nameOnAccount = preferredPayment.nameOnAccount;
          this.form.routingNumber = preferredPayment.routingNumber;
          this.form.accountNumber = preferredPayment.accountNumber;
          this.form.bankName = preferredPayment.bankName;
          this.form.relationshipOther = preferredPayment.relationshipOther;
        }

        this.participantDetails = getEnrolleeInitials(newEnrollees, this.enrolleeType);
      }
    },
  },
  async created() {
    this.enrollmentId = this.$route.params.enrollmentId;
    this.enrolleeId = this.$route.params.enrolleeId;
    this.enrolleeType = this.$route.params.enrolleeType;
    await this.loadEnrollees(this.$route.params.enrolleeId);
  },
};
</script>

<style></style>
